import { render } from "./add-pages.vue?vue&type=template&id=ec2bf652"
import script from "./add-pages.vue?vue&type=script&lang=js"
export * from "./add-pages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__